import { Component, Input, OnInit } from '@angular/core';
import { AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';

@Component({
  selector: 'app-show-header-data',
  templateUrl: './show-header-data.component.html',
  styleUrls: ['./show-header-data.component.scss']
})
export class ShowHeaderDataComponent implements OnInit {
  @Input() title: string;
  @Input() id: number;
  @Input() state: string;
  @Input() areaType: AreaTypeEnum;

  constructor() {}

  ngOnInit(): void {}
}
